function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledContactUsImage } from "./contact-us-image.scss";
class ContactUsImage extends PureComponent {
    render() {
        const { plan } = this.props;
        const { tier } = plan;
        const imgSrc = `/static/img/pricing/contact_us_plan_${tier}.png`;
        return /*#__PURE__*/ _jsx(StyledContactUsImage, {
            className: "tier-card-contact-us-image-container",
            children: /*#__PURE__*/ _jsx("div", {
                className: `contact-us-image-wrapper ${tier}`,
                children: /*#__PURE__*/ _jsx("img", {
                    src: imgSrc,
                    alt: this.getAltText()
                })
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getAltText", ()=>{
            const { translate, plan } = this.props;
            const { displayName } = plan;
            return `${translate("footer.contactUs")} - ${translate(displayName)}`;
        });
    }
}
export default withGenericConfig(ContactUsImage);
